import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PageHero } from "@/components/PageHero";
import { ProjectCard } from "@/components/ProjectCard";
import { CTASection } from "@/components/CTASection";
import { PROJECTS, PROJECT_FILTERS } from "@/data/content";
import { useSEO } from "@/lib/useSEO";

export default function Projects() {
  useSEO({
    title: "Projects | Tangensis Business Solutions",
    description: "Explore where Tangensis creates measurable impact — digital transformation, growth strategy, process optimization, technology consulting and international market expansion.",
    path: "/projects",
  });
  const [filter, setFilter] = useState("ALL");
  const filtered = filter === "ALL" ? PROJECTS : PROJECTS.filter((p) => p.category === filter);

  return (
    <>
      <PageHero
        label="Selected work"
        titleLines={["OUR", "PROJECTS."]}
        intro="Explore the areas where Tangensis Business Solutions creates measurable impact — from digital transformation and growth strategy to technology consulting and international market expansion."
      />

      <section className="bg-white pb-16 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-3 py-10 border-b border-brand-ink/10" data-testid="project-filters">
            {PROJECT_FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`filter-${f.toLowerCase()}`}
                className={`text-sm font-semibold tracking-widest rounded-full px-5 py-2.5 transition-colors duration-300 ${
                  filter === f ? "gradient-bg text-white" : "text-brand-ink/75 border border-brand-ink/15 hover:text-brand-primary hover:border-brand-primary/40"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          <motion.div layout className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
            <AnimatePresence mode="popLayout">
              {filtered.map((p, i) => (
                <motion.div
                  key={p.id}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.4 }}
                >
                  <ProjectCard project={p} index={i} />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      <CTASection heading={["HAVE A PROJECT", "IN MIND?"]} />
    </>
  );
}
